exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.switch-company-container{position:absolute;overflow:hidden;right:195px;top:58px;width:0;height:178px;background-image:url(" + require("../../assets/images/switch-company-card.svg") + ");background-repeat:no-repeat;z-index:25}.switch-company-container .switch-company-label{position:absolute;width:100%}.switch-company-container .switch-company-label .switch-company-icon{position:absolute;top:17px;left:25px}.switch-company-container .switch-company-label .switch-company-title{position:absolute;left:48px;top:16px;font-family:Open Sans,sans-serif;font-weight:600;font-size:11px;color:#6d6e71;letter-spacing:0}.switch-company-container .switch-company-combobox-container{position:absolute;top:48px;left:25px}.switch-company-container .switch-company-combobox-container .switch-company-combobox-label{font-family:Open Sans,sans-serif;font-weight:300;font-size:10px;color:#8b8b8b;letter-spacing:1px}.switch-company-container .switch-company-combobox-container .switch-company-combobox{position:relative;width:217px;height:30px;border:1px solid #b8b8b8;text-indent:12px}.switch-company-container .switch-company-combobox-container .switch-company-combobox img{top:12px;right:12px}.switch-company-container .switch-company-combobox-container .switch-company-combobox .lds-ellipsis{position:absolute;top:3px;right:8px;transform:scale(.5)}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/SwitchCompany/SwitchCompany.scss
// module id = 1622
// module chunks = 0